// The fields Core redacts from a link in the block payload and in every PUT response: a locked link (and each child of a
// locked group) arrives without its destination (url, urlRaw, file, modal, sublinks, widgetData) or its Instagram DM
// automation's message, and no lock carries its PIN or password. Only the owner's
// GET api/link-blocks/{blockId}/items[/{id}] returns them.
export const OWNER_ONLY_LINK_FIELDS = ['url', 'urlRaw', 'file', 'modal', 'sublinks', 'widgetData', 'instagramDMAutomations', 'lockData'];

// The link with the owner-only fields taken from `source`
export const withOwnerLinkFields = (link, source) => {
  const ownerFields = {};

  OWNER_ONLY_LINK_FIELDS.forEach((field) => {
    ownerFields[field] = source?.[field];
  });

  return { ...link, ...ownerFields };
};

// A link from a PUT response, keeping the owner-only fields the store already holds instead of the redacted ones
export const keepOwnerLinkFields = (storedLink, responseLink) => withOwnerLinkFields(responseLink, storedLink);

// Redacted in the block payload: a locked link, and a group, whose children come redacted when it or they are locked
const hasOwnerOnlyData = (link) => Boolean(link.isLocked) || link.urlType === 'group';

export const needsOwnerLinks = (links) => (links ?? []).some(hasOwnerOnlyData);

// The block's links, with each locked link and each group taking its owner-only fields from the owner list
export const mergeOwnerLinks = (links, ownerLinks) => {
  const ownerById = new Map((ownerLinks ?? []).map((ownerLink) => [ownerLink.id, ownerLink]));

  return (links ?? []).map((link) => {
    const ownerLink = ownerById.get(link.id);

    return ownerLink && hasOwnerOnlyData(link) ? withOwnerLinkFields(link, ownerLink) : link;
  });
};
